const SignupActionTypes = {
  REGISTER_USER_START: "REGISTER_USER_START",
  REGISTER_USER_SUCCESS: "REGISTER_USER_SUCCESS",
  REGISTER_USER_FAILURE: "REGISTER_USER_FAILURE",

  FETCH_USER_START: "FETCH_USER_START",
  FETCH_USER_SUCCESS: "FETCH_USER_SUCCESS",
  FETCH_USER_FAILURE: "FETCH_USER_FAILURE",

  SET_USER_DETAILS: "SET_USER_DETAILS",
  SET_PAYMENT_PLAN: "SET_PAYMENT_PLAN",
  SET_CURRENT_FORM: "SET_CURRENT_FORM",

  SET_ERROR_MESSAGE: "SET_ERROR_MESSAGE",

  FORGOT_PASSWORD_START: "FORGOT_PASSWORD_START",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE: "FORGOT_PASSWORD_FAILURE",

  CHANGE_PASSWORD_START: "CHANGE_PASSWORD_START",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILURE: "CHANGE_PASSWORD_FAILURE",

  SET_IS_SIGNING_UP: "SET_IS_SIGNING_UP",
  INITIALIZE_SIGNUP_STATE: "INITIALIZE_SIGNUP_STATE",

  VERIFY_EMAIL_START: "VERIFY_EMAIL_START",
  VERIFY_EMAIL_SUCCESS: "VERIFY_EMAIL_SUCCESS",
  VERIFY_EMAIL_FAILURE: "VERIFY_EMAIL_FAILURE",

  SUBSCRIBED_SUCCESS: "SUBSCRIBED_SUCCESS",
  SUBSCRIBED_FAILURE: "SUBSCRIBED_FAILED",

  BODY_SCANNED_FAILURE: "BODY_SCANNED_FAILURE",
  BODY_SCANNED_SUCCESS: "BODY_SCANNED_SUCCESS",
  FACE_SCANNED_FAILURE: "FACE_SCANNED_FAILURE",
  FACE_SCANNED_SUCCESS: "FACE_SCANNED_SUCCESS",

  SET_GUEST_DETAILS: "SET_GUEST_DETAILS",
  GUEST_BODY_SCANNED_FAILURE: "GUEST_BODY_SCANNED_FAILURE",
  GUEST_BODY_SCANNED_SUCCESS: "GUEST_BODY_SCANNED_SUCCESS",
  GUEST_FACE_SCANNED_FAILURE: "GUEST_FACE_SCANNED_FAILURE",
  GUEST_FACE_SCANNED_SUCCESS: "GUEST_FACE_SCANNED_SUCCESS",

  SET_INTEREST_CATEGORIES: "SET_INTEREST_CATEGORIES",
  DUMMY_TEST: "TEST",
};

export default SignupActionTypes;
